import React, { useState } from "react";
import { func } from "prop-types";
import I18n from "pages/_components/I18n";

import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import { Checkbox } from "pages/_components/fields/Checkbox";

const TermsConditionTransmit = ({ handleAccept, handleReject, handleClickDownloadPdf }) => {
    const [acceptTerm, setAcceptTerm] = useState(false);

    return (
        <div className="container above-the-fold">
            <Row />
            <Row />
            <Row />
            <Row>
                <Col xs={12} md={6} mdOffset={3}>
                    <I18n id="cedip.transmit.terms.condition.title" component="h2" />
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <I18n id="cedip.transmit.terms.condition.info.1" component="p" />
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <I18n id="cedip.transmit.terms.condition.info.2" component="p" />
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <I18n id="cedip.transmit.terms.condition.info.3" component="p" />
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <button
                        id="btn-downloaPDF"
                        type="button"
                        className="btn btn-asLink"
                        onClick={() => handleClickDownloadPdf()}>
                        <I18n id="generalConditions.term.download" />
                    </button>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <Checkbox
                        name="acceptBtn"
                        label={<I18n id="cedip.transmit.terms.condition.info.check" />}
                        onChange={() => setAcceptTerm(!acceptTerm)}
                        value={acceptTerm}
                        checked={acceptTerm}
                        formGroup={false}
                    />
                </Col>
                <Col xs={12} md={6} mdOffset={3}>
                    <Button
                        onClick={handleAccept}
                        className="btn-primary"
                        label="accept.cedip.transmit"
                        disabled={!acceptTerm}
                    />
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs={12} md={6} mdOffset={3}>
                    <Button className="btn-outline" label="reject.cedip.transmit" onClick={handleReject} />
                </Col>
            </Row>
        </div>
    );
};

TermsConditionTransmit.propTypes = {
    handleAccept: func.isRequired,
    handleReject: func.isRequired,
    handleClickDownloadPdf: func.isRequired,
};

export default TermsConditionTransmit;
